import PropTypes from 'prop-types';
import React from 'react';
import first from 'lodash/first';
import map from 'lodash/map';
import { formatISO } from 'date-fns';
import { Button, FAIcon } from 'reactifi';
import { MaterialCheckbox } from '@everfi/reactifi';
import i18n from 'lib/utility/i18n';
import Ibox from 'lib/components/Ibox';
import CustomizationHelper from './CustomizationHelper';

export default class CustomizationForm extends React.Component {
  static propTypes = {
    object: PropTypes.object.isRequired,
    onUpdate: PropTypes.func,
    children: PropTypes.node.isRequired,
    level: PropTypes.string.isRequired,
    toggleOnly: PropTypes.bool,
  };

  static defaultProps = {
    toggleOnly: false,
    onUpdate: () => {},
  };

  constructor(props) {
    super(props);

    this.helper = new CustomizationHelper(this.props.object, this.props.level);
    this.state = {
      savedStatus: null,
    };
  }

  componentDidUpdate() {
    this.helper = new CustomizationHelper(this.props.object, this.props.level);
  }

  toggleEnabled = () => {
    const object = Object.assign(this.props.object, {
      enabled: !this.props.object.enabled,
    });

    // do not call onUpdate twice (once here, once in onSuccess) for toggle-only operations
    if (!this.toggleOnly) {
      this.props.onUpdate(object);
    }

    this.submit();
  };

  submit = (event) => {
    if (event) event.preventDefault();

    let attrs = this.props.object;
    if (attrs.module_default) {
      delete attrs.activity_key;
      delete attrs.page_key;
      delete attrs.content;
      delete attrs.program;
      delete attrs.account;
    }

    this.setState(
      Object.assign({}, this.state, { saving: true, savedStatus: 'saving' })
    );

    $.ajax({
      dataType: 'JSON',
      method: this.helper.method,
      url: this.helper.url,
      data: { customization: attrs },
      success: this.onSuccess,
      error: this.onError,
    });
  };

  onError = (response) => {
    const errors =
      response && response.responseJSON ? response.responseJSON.errors : null;
    this.setState(
      Object.assign({}, this.state, {
        saving: true,
        savedStatus: 'error',
        errors,
      })
    );
  };

  onSuccess = (object) => {
    object = Object.assign(this.props.object, object);
    // Use a timeout here, to make the save indicator more obvious
    setTimeout(() => {
      this.setState(
        Object.assign({}, this.state, {
          saving: true,
          savedStatus: 'saved',
          errors: null,
        })
      );
    }, 300);

    if (this.props.object.deleted_at) {
      window.location.reload();
    } else {
      this.props.onUpdate(object);
    }
  };

  renderErrors = () => {
    const firstError = first(this.state.errors);
    const errorContent =
      firstError instanceof String ? (
        map(this.state.errors, (errors, field) => (
          <li>
            {field}: {errors.join(', ')}
          </li>
        ))
      ) : (
        <li>{firstError.title}</li>
      );

    return (
      <div className="alert alert-danger">
        <ul>{errorContent}</ul>
      </div>
    );
  };

  status = () => {
    switch (this.state.savedStatus) {
    case 'saving':
      return (
        <span className="badge-pill badge-success">
            SAVING <FAIcon icon="rotate" spin={true} />
        </span>
      );
    case 'error':
      return (
        <span className="badge-pill badge-danger">
            ERROR SAVING <FAIcon icon="triangle-exclamation" />
        </span>
      );
    default:
      break;
    }
  };

  enableText = () => {
    return this.props.object.enabled ? 'Disable' : 'Enable';
  };

  get toggleOnly() {
    return this.props.toggleOnly;
  }

  renderTools() {
    return (
      <span>
        {this.status()} &nbsp;
        <Button
          label={this.enableText()}
          onClick={this.toggleEnabled}
          style="secondary"
          chakra="off"
        />
      </span>
    );
  }

  updateDeteledAt = (event, customization) => {
    customization.deleted_at = event ? formatISO(new Date()) : null;
  };

  render() {
    const { object } = this.props;
    return (
      <div className="p-2">
        <Ibox
          title={object.title}
          tools={this.renderTools()}
          collapse={!object.enabled || this.toggleOnly}
        >
          {this.state.errors ? this.renderErrors() : null}
          <form className="form-horizonal" onSubmit={this.submit}>
            {object.enabled ? this.props.children : null}
            <div className="m-t-md clearfix">
              {object.module_default ? null : (
                <div className="pull-left">
                  <MaterialCheckbox
                    label={i18n.t('Mark this customization as deleted')}
                    id={object.title}
                    onChange={(event) => this.updateDeteledAt(event, object)}
                  />
                </div>
              )}
              <div className="pull-right">
                <Button
                  renderAsLegacy={true}
                  label="Save"
                  style="primary"
                  type="submit"
                />
              </div>
            </div>
          </form>
        </Ibox>
      </div>
    );
  }
}
